const COUNTRY_ALIASES = {
  NO: 'NO',
  NORWAY: 'NO',
  NORGE: 'NO',
};

const formatUtcDate = (date) => {
  const year = date.getUTCFullYear();
  const month = `${date.getUTCMonth() + 1}`.padStart(2, '0');
  const day = `${date.getUTCDate()}`.padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const createUtcDate = (year, monthIndex, day) =>
  new Date(Date.UTC(year, monthIndex, day));

const addUtcDays = (date, days) => {
  const nextDate = new Date(date);
  nextDate.setUTCDate(nextDate.getUTCDate() + days);
  return nextDate;
};

const getEasterSunday = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  return createUtcDate(year, month - 1, day);
};

const getNorwayPublicHolidayDates = (year) => {
  const easterSunday = getEasterSunday(year);

  return [
    createUtcDate(year, 0, 1),
    addUtcDays(easterSunday, -3),
    addUtcDays(easterSunday, -2),
    easterSunday,
    addUtcDays(easterSunday, 1),
    createUtcDate(year, 4, 1),
    createUtcDate(year, 4, 17),
    addUtcDays(easterSunday, 39),
    addUtcDays(easterSunday, 49),
    addUtcDays(easterSunday, 50),
    createUtcDate(year, 11, 25),
    createUtcDate(year, 11, 26),
  ].map(formatUtcDate);
};

const HOLIDAY_PROVIDERS = {
  NO: getNorwayPublicHolidayDates,
};

export const normalizeCountryCode = (country) => {
  if (typeof country === 'object' && country !== null) {
    return normalizeCountryCode(
      country.code ?? country.countryCode ?? country.name ?? ''
    );
  }

  const normalizedCountry = `${country ?? ''}`.trim().toUpperCase();

  if (!normalizedCountry) {
    return 'NO';
  }

  return COUNTRY_ALIASES[normalizedCountry] ?? normalizedCountry;
};

export const getPublicHolidayDateSet = (country, years = []) => {
  const normalizedCountry = normalizeCountryCode(country);
  const holidayProvider = HOLIDAY_PROVIDERS[normalizedCountry] ?? HOLIDAY_PROVIDERS.NO;

  return new Set(
    years.flatMap((year) => {
      if (!Number.isInteger(year)) {
        return [];
      }

      return holidayProvider(year);
    })
  );
};
